import * as React from 'react'

import { Chevron, useToggle } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import { observer } from 'mobx-react'

import type LeaveModel from 'modules/timeoff/store/models/Leave'
import type MedicalLeaveUpdate from 'modules/timeoff/store/models/MedicalLeaveUpdate'

import UpdateItem from './Update'
import * as styles from './index.vanilla.css'

interface Props {
  leave: LeaveModel
  updates: MedicalLeaveUpdate[]
}

const cx = classNames.bind(styles)

const Updates = ({ leave, updates }: Props) => {
  const isMedical = leave.leaveType?.isMedicalLeave
  const [open, toggle] = useToggle()
  const direction = open ? 'up' : 'down'

  if (!isMedical) return null
  return (
    <div className={styles.updates}>
      <>
        <ul
          className={cx('list', {
            open,
          })}
        >
          {updates.map((update) => (
            <li key={update.attributes.id} className={styles.item}>
              <UpdateItem update={update} leave={leave} />
            </li>
          ))}
          <li className={styles.item}>
            <UpdateItem leave={leave} />
          </li>
        </ul>
        <div className={styles.showMore} onClick={toggle(!open)}>
          <div className={styles.showMoreContent}>
            <Chevron type="terciary" direction={direction} />
          </div>
        </div>
      </>
    </div>
  )
}

export default observer(Updates)
